export default {
  AUTHENTICATE_LOGIN: "/UserInfo/AdminLogin",
  AUTHENTICATE_SIGNUP: "/UserInfo/create",
  AUTHENTICATE_FORGOT_PASSWORD: "/UserInfo/ForgetPassword",
  SYNC_INFO: "/user/SyncInfo",
};
